import { createTheme } from "@material-ui/core/styles";
import { themeColors } from "./themeColors";

export const apps = [
  {
    name: "colfactura",
    title: "Colfactura",
    backgroundImage: "colfacturaBackground.png",
    logo: "colfacturaLogo.png",
    whiteGseLogo: "whiteGseLogo.png",
    icon: "colfacturaIco.ico",
  },
  {
    name: "GSE Suite",
    title: "Suite GSE",
    backgroundImage: "gseBackground.jpg",
    logo: "gseLogo.png",
    whiteGseLogo: "whiteGseLogo.png",
    icon: "gsefavicon.ico",
  },
  {
    name: "oidc",
    title: "OIDC",
    backgroundImage: "gseBackground.jpg",
    logo: "gseLogo.png",
    whiteGseLogo: "whiteGseLogo.png",
    icon: "gsefavicon.ico",
  },
  {
    name: "firmaya",
    title: "Firmaya",
    backgroundImage: "firmayaBackground.png",
    logo: "firmayaLogo.png",
    whiteGseLogo: "whiteGseLogo.png",
    icon: "firmayaIco.ico",
  },
  {
    name: "firmaya_bmsfirmado",
    title: "Solución de Firmado",
    backgroundImage: "firmadoBackground.png",
    logo: "firmadoLogo.png",
    whiteGseLogo: "whiteGseLogo.png",
    icon: "bmsfirmado.ico",
  },
  {
    name: "ibuhoo",
    title: "Suite GSE",
    backgroundImage: "gseBackground.jpg",
    logo: "gseLogo.png",
    whiteGseLogo: "whiteGseLogo.png",
    icon: "gsefavicon.ico",
  },
  {
    name: "license",
    title: "License",
    backgroundImage: "gseBackground.jpg",
    logo: "gseLogo.png",
    whiteGseLogo: "whiteGseLogo.png",
    icon: "gsefavicon.ico",
  },
  {
    name: "colnomina",
    title: "Colfactura Nómina",
    backgroundImage: "colnominaBackground.png",
    logo: "colnominaLogo.png",
    whiteGseLogo: "whiteGseLogo.png",
    icon: "colfacturaIco.ico",
  },
  {
    name: "biometria",
    title: "Biometria",
    backgroundImage: "gseBackground.jpg",
    logo: "gseLogo.png",
    whiteGseLogo: "whiteGseLogo.png",
    icon: "gsefavicon.ico",
  },
  {
    name: "biometria_gse",
    title: "Biometria",
    backgroundImage: "gseBackground.jpg",
    logo: "gseLogo.png",
    whiteGseLogo: "whiteGseLogo.png",
    icon: "gsefavicon.ico",
  },
  {
    name: "biometria_fna",
    title: "Biometria",
    backgroundImage: "gseBackground.jpg",
    logo: "gseLogo.png",
    whiteGseLogo: "whiteGseLogo.png",
    icon: "gsefavicon.ico",
  },
  {
    name: "confronta",
    title: "Confronta",
    backgroundImage: "gseBackground.jpg",
    logo: "gseLogo.png",
    whiteGseLogo: "whiteGseLogo.png",
    icon: "gsefavicon.ico",
  },
  {
    name: "myselfcert",
    title: "Certificación Digital - GSE",
    backgroundImage: "LoginUko.png",
    logo: "gseLogo.png",
    whiteGseLogo: "whiteGseLogo.png",
    icon: "gsefavicon.ico",
  },
  {
    name: "letmicert",
    title: "Certificación Digital - Letmi",
    backgroundImage: "LoginUko.png",
    logo: "gseLogo.png",
    whiteGseLogo: "whiteGseLogo.png",
    icon: "letmicert_ico.ico",
  },
  {
    name: "pancert",
    title: "Certificación Digital - Panamá",
    backgroundImage: "LoginUko.png",
    logo: "gseLogo.png",
    whiteGseLogo: "whiteGseLogo.png",
    icon: "letmicert_ico.ico",
  },
  {
    name: "license_letmicert",
    title: "Licenciamiento - Letmi",
    backgroundImage: "letmiLicenseBackground.png",
    logo: "letmicertLogo.svg",
    whiteGseLogo: "whiteGseLogo.png",
    icon: "letmicert_ico.ico",
  },
  {
    name: "license_pancert",
    title: "Licenciamiento - Panamá",
    backgroundImage: "azul.png",
    logo: "letmicertLogo.svg",
    whiteGseLogo: "whiteGseLogo.png",
    icon: "letmicert_ico.ico",
  },
  {
    name: "license_myselfcert",
    title: "license_myselfcert",
    backgroundImage: "gseBackground.jpg",
    logo: "gseLogo.png",
    whiteGseLogo: "whiteGseLogo.png",
    icon: "gsefavicon.ico",
  },
  {
    name: "lstinhib",
    title: "Listas inhibitorias - GSE",
    backgroundImage: "LoginUko.png",
    logo: "gseLogo.png",
    whiteGseLogo: "whiteGseLogo.png",
    icon: "gsefavicon.ico",
  },
  {
    name: "lstinhib_gse",
    title: "Credencial de confianza",
    backgroundImage: "LoginUko.png",
    logo: "gseLogo.png",
    whiteGseLogo: "whiteGseLogo.png",
    icon: "gsefavicon.ico",
  },
  {
    name: "lstinhib_paynet",
    title: "Credencial de confianza",
    backgroundImage: "LoginUko.png",
    logo: "gseLogo.png",
    whiteGseLogo: "whiteGseLogo.png",
    icon: "gsefavicon.ico",
  },
  {
    name: "projectk",
    title: "Proyecto K",
    backgroundImage: "LoginUko.png",
    logo: "gseLogo.png",
    whiteGseLogo: "whiteGseLogo.png",
    icon: "Calesas.ico",
  },
  {
    name: "colfactura_cfweb",
    title: "Colfactura",
    backgroundImage: "LoginUko.png",
    logo: "gseLogo.png",
    whiteGseLogo: "whiteGseLogo.png",
    icon: "colfacturaIco.ico",
  },
];

export const muiTheme = (appName, tenant) => {
  if (tenant) {
    appName = appName + "_" + tenant;
  }
  const { backgroundImage, logo, icon } = apps.filter(
    (item) => item.name === appName
  )[0];
  var favicon = document.getElementById("favicon");
  favicon.href = `/${icon}`;
  return createTheme({
    palette: {
      primary: {
        light: `${themeColors[appName]["primary"]["light"]}`,
        main: `${themeColors[appName]["primary"]["main"]}`,
        dark: `${themeColors[appName]["primary"]["dark"]}`,
        iconSend: `${themeColors[appName]["primary"]["iconSend"]}`,
      },
      secondary: {
        light: `${themeColors[appName]["secondary"]["light"]}`,
        main: `${themeColors[appName]["secondary"]["main"]}`,
        dark: `${themeColors[appName]["secondary"]["dark"]}`, //claro
        titleText:`${themeColors[appName]["secondary"]["titleText"]}`
      },
      info: {
        light: `${themeColors[appName]["info"]["light"]}`,
        main: `${themeColors[appName]["info"]["main"]}`,
        dark: `${themeColors[appName]["info"]["dark"]}`,
      },
      error: {
        light: `${themeColors[appName]["error"]["light"]}`,
        main: `${themeColors[appName]["error"]["main"]}`,
        dark: `${themeColors[appName]["error"]["dark"]}`,
        secondary: `${themeColors[appName]["error"]["secondary"]}`,
        typographyColor: `${themeColors[appName]["error"]["typographyColor"]}`,
      },
      text: {
        primary: "#575756",
        secondary: "#FFFFFF",
        disabled: "#B2B2B2",
      },
      common: {
        grey: "#A8A8A8",
        black: "#575756",
        white: "#FFFFFF",
      },
      background: {
        paper: `${themeColors[appName]["background"]["paper"]}`,
        input: `${themeColors[appName]["background"]["input"]}`,
        adornmentPrimary: `${themeColors[appName]["background"]["adornmentPrimary"]}`,
        adornmentSecondary: `${themeColors[appName]["background"]["adornmentSecondary"]}`,
        certificateButtonColor: `${themeColors[appName]["background"]["certificateButtonColor"]}`,
        forgotPasswordButton: `${themeColors[appName]["background"]["forgotPasswordButton"]}`,
        selectIcon: `${themeColors[appName]["background"]["selectIcon"]}`,
        disabledButtonColor: `${themeColors[appName]["background"]["disabledButtonColor"]}`,
        backButtonColor: `${themeColors[appName]["background"]["backButtonColor"]}`,
        codeInputBorderColor: `${themeColors[appName]["background"]["codeInputBorderColor"]}`,
        selectColorDefault: `${themeColors[appName]["background"]["selectColorDefault"]}`,
        selectUsersCertificates: `${themeColors[appName]["background"]["selectUsersCertificates"]}`,
        hr:`${themeColors[appName]["background"]["hr"]}`
      },
      letter: {
        color: `${themeColors[appName]["letter"]["color"]}`,
        disabledColor: `${themeColors[appName]["letter"]["disabledColor"]}`,
        typographyColor: `${themeColors[appName]["letter"]["typographyColor"]}`,
        codeInputTypographyColor: `${themeColors[appName]["letter"]["codeInputTypographyColor"]}`
      }
    },
    logo: {
      backgroundImage: `url('/${logo}')`,
    },
    logoSettings: {
      widthResendEmail: `${themeColors[appName]["logoSettings"]["widthResendEmail"]}`,
      heightResendEmail: `${themeColors[appName]["logoSettings"]["heightResendEmail"]}`,
      marginLeftResendEmail: `${themeColors[appName]["logoSettings"]["marginLeftResendEmail"]}`,
      widthResetPwd: `${themeColors[appName]["logoSettings"]["widthResetPwd"]}`,
      heightAlertResetPassword: `${themeColors[appName]["logoSettings"]["heightAlertResetPassword"]}`,
      heightResetPassword: `${themeColors[appName]["logoSettings"]["heightResetPassword"]}`,
      marginLeftResetPassword: `${themeColors[appName]["logoSettings"]["marginLeftResetPassword"]}`,
      widthImage: `${themeColors[appName]["logoSettings"]["widthImage"]}`,
    },
    pageBackground: {
      backgroundImage: `url('/${backgroundImage}')`,
      backgroundSize: "cover",
    },
    typography: {
      fontFamily: ["Muli", "Arial", "sans-serif"].join(","),
      colorMessageUko: `${themeColors[appName]["typographyMessageUko"]["textColor"]}`,
    },
    urlLogo: {
      url: `${themeColors[appName]["urlLogo"]["url"]}`,
      urlSignIn: `${themeColors[appName]["urlLogo"]["urlSignIn"]}`,
      urlRememberPasswordlogo: `${themeColors[appName]["urlLogo"]["urlRememberPasswordlogo"]}`,
      urlCheckEmaillogo: `${themeColors[appName]["urlLogo"]["urlCheckEmaillogo"]}`,
      urlRemeberAndInvalid: `${themeColors[appName]["urlLogo"]["urlRemeberAndInvalid"]}`,
      urlInvalidLinkMoreBlue: `${themeColors[appName]["urlLogo"]["urlInvalidLinkMoreBlue"]}`,
      urlChangePasswordlogo: `${themeColors[appName]["urlLogo"]["urlChangePasswordlogo"]}`,
      urlActivatePasswordlogo: `${themeColors[appName]["urlLogo"]["urlActivatePasswordlogo"]}`,
      urlMaintenanceImage: `${themeColors[appName]["urlLogo"]["urlMaintenanceImage"]}`,
      urlWhiteGseLogo: `${themeColors[appName]["urlLogo"]["urlWhiteGseLogo"]}`,
      urlSuccessAlertlogo: `${themeColors[appName]["urlLogo"]["urlSuccessAlertlogo"]}`,
      urlSuccessAccountActivated: `${themeColors[appName]["urlLogo"]["urlSuccessAccountActivated"]}`,
      urlExpireTime: `${themeColors[appName]["urlLogo"]["urlExpireTime"]}`,
      urlCheckEmailAgain: `${themeColors[appName]["urlLogo"]["urlCheckEmailAgain"]}`,
      urlCheckEmailMoreBlue: `${themeColors[appName]["urlLogo"]["urlCheckEmailMoreBlue"]}`,
      urlPasswordResetLogo: `${themeColors[appName]["urlLogo"]["urlPasswordResetLogo"]}`,
      urlResendEmailLogo: `${themeColors[appName]["urlLogo"]["urlResendEmailLogo"]}`,
      urlAlert: `${themeColors[appName]["urlLogo"]["urlAlert"]}`,
    },
    InputUko: {
      colorInputLetter: `${themeColors[appName]["InputUko"]["colorInputLetter"]}`,
      borderInput: `${themeColors[appName]["InputUko"]["borderInput"]}`,
      colorLabel: `${themeColors[appName]["InputUko"]["colorLabel"]}`,
      colorLabelFocus: `${themeColors[appName]["InputUko"]["colorLabelFocus"]}`,
      colorIcon: `${themeColors[appName]["InputUko"]["colorIcon"]}`,
      backgroundColor:`${themeColors[appName]["InputUko"]["backgroundColor"]}`
    },
    buttonUko: {
      buttonUkoBackgroundDisabled: `${themeColors[appName]["buttonUko"]["buttonUkoBackgroundDisabled"]}`,
      buttonUkoColorDisabled: `${themeColors[appName]["buttonUko"]["buttonUkoColorDisabled"]}`,
      buttonUkoBackgroundActive: `${themeColors[appName]["buttonUko"]["buttonUkoBackgroundActive"]}`,
      buttonUkoBackgroundSuccess: `${themeColors[appName]["buttonUko"]["buttonUkoBackgroundSuccess"]}`,
      buttonUkoColorDisabledResetPwd: `${themeColors[appName]["buttonUko"]["buttonUkoColorDisabledResetPwd"]}`,
    },
    linkUko: {
      colorLink: `${themeColors[appName]["linkUko"]["colorLink"]}`,
    },
    versionUko: {
      colorVersionLabel: `${themeColors[appName]["versionUko"]["colorVersionLabel"]}`,
    },
    alertUko: {
      imageUko: `${themeColors[appName]["alertUko"]["imageUko"]}`,
      colorTextUko: `${themeColors[appName]["alertUko"]["colorTextUko"]}`,
    },
    forgotPassword: {
      colorForgotPwd: `${themeColors[appName]["forgotPassword"]["colorForgotPwd"]}`,
    },
    typographyText: {
      textColor: `${themeColors[appName]["typographyText"]["textColor"]}`,
      pathColor: `${themeColors[appName]["typographyText"]["pathColor"]}`,
    },
    selectAccount: {
      colorRoot: `${themeColors[appName]["selectAccount"]["colorRoot"]}`,
      colorChecked: `${themeColors[appName]["selectAccount"]["colorChecked"]}`,
    },
    widthImageLogo: `${themeColors[appName]["widthImageLogo"]}`,
    colorLoading: `${themeColors[appName]["colorLoading"]}`,
    errorBox: {
      color: `${themeColors[appName]["errorBox"]["color"]}`,
      backgroundColor: `${themeColors[appName]["errorBox"]["backgroundColor"]}`,
    },
    statusLicense: {
      containerMessage: {
        backgroundColor: `${themeColors[appName]["statusLicense"]["containerMessage"]["backgroundColor"]}`,
      },
    },
    alertPopup: {
      iconClose: {
        color: `${themeColors[appName]["alertPopup"]["iconClose"]["color"]}`,
      },
      titleAlert: {
        color: `${themeColors[appName]["alertPopup"]["titleAlert"]["color"]}`,
      },
      buttonCancel: {
        backgroundColor: `${themeColors[appName]["alertPopup"]["buttonCancel"]["backgroundColor"]}`,
        color: `${themeColors[appName]["alertPopup"]["buttonCancel"]["color"]}`,
        '&:hover': {
          backgroundColor: `${themeColors[appName]["alertPopup"]["buttonCancel"]["&:hover"]["backgroundColor"]}`,
        },
      },
      buttonAccept: {
        backgroundColor: `${themeColors[appName]["alertPopup"]["buttonAccept"]["backgroundColor"]}`,
        color: `${themeColors[appName]["alertPopup"]["buttonAccept"]["color"]}`,
        '&:hover': {
          backgroundColor: `${themeColors[appName]["alertPopup"]["buttonAccept"]["&:hover"]["backgroundColor"]}`,
        },
      },
      secondaryMessageText: {
        color: `${themeColors[appName]["alertPopup"]["secondaryMessageText"]["color"]}`,
      },
      mensajeModalMain: { 
      },
    },
    iconColorError: {
      appBgColorCards: {
        boxShadow: `${themeColors[appName]["iconColorError"]["appBgColorCards"]["boxShadow"]}`, 
      },
      rootCard: {},
      title: {
        color: `${themeColors[appName]["iconColorError"]["title"]["color"]}`,
      },
      subtitle: {
        color: `${themeColors[appName]["iconColorError"]["subtitle"]["color"]}`,
      },
      cardHeader: {
        color: `${themeColors[appName]["iconColorError"]["cardHeader"]["color"]}`,
      },
      featureName: {},
      featureValue: {
        color: `${themeColors[appName]["iconColorError"]["featureValue"]["color"]}`,
      },
      buttonCard: {
        backgroundColor: `${themeColors[appName]["iconColorError"]["buttonCard"]["backgroundColor"]}`,
        color: `${themeColors[appName]["iconColorError"]["buttonCard"]["color"]}`,
      },
      hoverButtonCard: {
        color: `${themeColors[appName]["iconColorError"]["hoverButtonCard"]["color"]}`,
        backgroundColor: `${themeColors[appName]["iconColorError"]["hoverButtonCard"]["backgroundColor"]}`,
      },
      iconCard: {
        color: `${themeColors[appName]["iconColorError"]["iconCard"]["color"]}`,
      },
      btnDirectPlan: {
        backgroundColor: `${themeColors[appName]["iconColorError"]["btnDirectPlan"]["backgroundColor"]}`,
        color: `${themeColors[appName]["iconColorError"]["btnDirectPlan"]["color"]}`,
        '&:hover': {
          backgroundColor: `${themeColors[appName]["iconColorError"]["btnDirectPlan"]["&:hover"]["backgroundColor"]}`,
        },
      },
      circularColor: {
        color: `${themeColors[appName]["iconColorError"]["circularColor"]["color"]}`,
      },
      tablePlanTable: {
        color: `${themeColors[appName]["iconColorError"]["tablePlanTable"]["color"]}`,
        backgroundColor: `${themeColors[appName]["iconColorError"]["tablePlanTable"]["backgroundColor"]}`,
        fontWeight: `${themeColors[appName]["iconColorError"]["tablePlanTable"]["fontWeight"]}`,
      },
      tableCellPlanTable: {
        color: `${themeColors[appName]["iconColorError"]["tableCellPlanTable"]["color"]}`,
        backgroundColor: `${themeColors[appName]["iconColorError"]["tableCellPlanTable"]["backgroundColor"]}`,
      },
      purchasedPlans: {
        color: `${themeColors[appName]["iconColorError"]["purchasedPlans"]["color"]}`,
        fontWeight: `${themeColors[appName]["iconColorError"]["purchasedPlans"]["fontWeight"]}`,
      },
      plansTypography: {
        color: `${themeColors[appName]["iconColorError"]["plansTypography"]["color"]}`,
        marginLeft: `${themeColors[appName]["iconColorError"]["plansTypography"]["marginLeft"]}`,
      },
      spanPlanTable: {
        color: `${themeColors[appName]["iconColorError"]["spanPlanTable"]["color"]}`,
      },
      reportIcon: {
        color: `${themeColors[appName]["iconColorError"]["reportIcon"]["color"]}`,
      },
    },
    passwordCheckColor:{
      borderInput: `${themeColors[appName]["passwordCheckColor"]["borderInput"]}`,
    },
  });
};
